import DataAccess from './constants';
import { genfunction } from '../helpers';
const path = 'BookingTypes'

export const apiBookingTypes = (id, isDisplayArea, listOfIds) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path;
    if (listOfIds && listOfIds != '') {

        url += '?BookingTypeIDList=' + listOfIds;
    }

    else {

        let newID = typeof id === 'object' && id !== null ? id.DisplayAreaNo : id;
        let newIsDisArea = typeof id === 'object' && id !== null ? id.isDisplay : isDisplayArea;

        url += (newIsDisArea ? "?DisplayArea=" + newID : "?BookingTypeID=" + newID);

    }

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}